import {
    IntegrationAccount,
    IntegrationAccountBase,
} from "./integrationAccount";
import { User, UserBase } from "./user";

export enum ConnectionProvider {
    PAYPAL = "PayPal",
    MERCURY = "Mercury",
    QUICKBOOKS = "QuickBooks",
    BILLCOM = "BILL",
    GUSTO = "Gusto",
    STRIPE = "Stripe",
    ADP_RUN = "ADP RUN",
}

/**
 * Base type for IntegrationConnection - allows undefined on relations.
 * Used by entity classes (TypeORM).
 */
export interface IntegrationConnectionBase {
    id: string;
    provider: ConnectionProvider;
    providerId: string | null;
    label: string | null;
    workspaceId: string | null;
    createdByUser?: UserBase | null;
    createdByUserId: number | null;
    createdAt: Date;
    institutionLogoUrl: string | null;
    institutionName: string | null;
    metadata: any;
    error: string | null;
    integrationAccounts?: IntegrationAccountBase[];
    entityId: number | null;
    counterpartiesSyncedAt: Date | null;
    classesSyncedAt: Date | null;
}

/**
 * Strict type for IntegrationConnection - requires loaded relations.
 * Used by DTOs and service boundaries after relations are loaded.
 */
export interface IntegrationConnection extends Omit<
    IntegrationConnectionBase,
    "createdByUser" | "integrationAccounts"
> {
    createdByUser?: User | null;
    integrationAccounts?: IntegrationAccount[];
}
